export const TimelineItem = ({ item }) => (
  <li className="flex flex-col md:flex-row gap-1 md:gap-6 py-5" style={{ borderBottom: "1px solid var(--border-default)", listStyle: "none" }}>
    <span className="caption shrink-0 md:pt-1" style={{ width: 148 }}>
      {item.years}
    </span>
    <div>
      <h4 className="text-h4 m-0 mb-1">{item.role}</h4>
      {item.institution && (
        <p className="body-sm m-0 mb-1" style={{ color: "var(--navy-500)" }}>
          {item.institution}
        </p>
      )}
      {item.detail && <p className="body-sm m-0">{item.detail}</p>}
    </div>
  </li>
);
